import { ReactElement } from 'react'
import styles from '../styles/FailModal.module.css'
import illustration from '../images/GameOver.jpg'

interface Props {
  onClose: () => void
}

const FailModal = ({ onClose }: Props): ReactElement => {
  return (
    <div className={styles.smokescreen}>
      <div className={styles.modal}>
        <div>
          <div className={styles.title}>Hups, väärä valinta!</div>
          <div className={styles.body}>Mutta ei se mitään, koska voit aina kokeilla uudelleen.</div>
          <button onClick={onClose}>Jatka seikkailua</button>
        </div>
        <div className={styles.illustration}>
          <img src={illustration} alt='Game over' />
        </div>
      </div>
    </div>
  )
}

export default FailModal
